import appStore from 'store'
import api from './api'
import { PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    tigerList: [],
    totalCount: 0,
    pagination: PAGINATION,
    rebateListTotal: {
      totalFee: 0, //手续费汇总
      rebateFee: 0, //手续费返佣
      rebateFeeSend: 0, //手续费返佣发放
    },
  },
  getters: {},
  mutations: {
    setTigerList(state, payload) {
      state.tigerList = payload.list.slice()
      state.totalCount = payload.totalCount
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setRebateListTotal(state, payload) {
      state.rebateListTotal = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getTigerList(query).then((res) => {
        if (res.code == 0) {
          commit('setTigerList', res.data)
        }
      })
    },
    fetchRebateListTotal({ commit }, query = {}) {
      api.getRebateListTotal(query).then((res) => {
        if (res.returnCode == 0) {
          commit('setRebateListTotal', res.result)
        }
      })
    },
  },
}

appStore.registerModule('rebateRisk', store)
